import { Component, Input } from '@angular/core';
import { AngularModule } from '../../../../../../modules/angular.module';
import { ZorroModule } from '../../../../../../modules/zorro.module';

@Component({
	selector: 'app-collapsible-section',
	standalone: true,
	imports: [AngularModule, ZorroModule],
	templateUrl: './collapsible-section.component.html',
	styleUrl: './collapsible-section.component.scss',
})
export class CollapsibleSectionComponent {
	@Input('title') public title: string = '';
	@Input('overflow') public overflow: boolean = false;

	public isCollapsed: boolean = false;

	public toggleCollapsed(): void {
		this.isCollapsed = !this.isCollapsed;
	}
}
